
interface GetIntervalAmountParams {
    propsPercent : number | undefined;
    defaultPercent : number;
    propsAnimationTime : number | undefined;
    defaultAnimationTime: number;
    intervalAmount: number;
}

export const getIntervalAmount = (params:GetIntervalAmountParams) => {
    return (
        ((params.propsPercent 
            ? params.propsPercent 
            : params.defaultPercent) * 100)/ 
        (((params.propsAnimationTime 
            ? params.propsAnimationTime 
            : params.defaultAnimationTime) * 500)/
        params.intervalAmount)
    )
}